import "./Fonts.css";

export default function Fonts() {
  return (
    <section className="ui-kit-section">
      <h2 className="ui-kit-title">Fonts</h2>

      <div className="ui-fonts">
        <FontRow label="8 - medium" className="fs-8 fw-medium" />

        <FontRow label="10 - regular" className="fs-10 fw-regular" />
        <FontRow label="10 - medium" className="fs-10 fw-medium" />
        <FontRow label="10 - bold" className="fs-10 fw-bold" />

        <FontRow label="12 - regular" className="fs-12 fw-regular" />
        <FontRow label="12 - medium" className="fs-12 fw-medium" />
        <FontRow label="12 - medium strike" className="fs-12 fw-medium strike" />
        <FontRow label="12 - bold" className="fs-12 fw-bold" />

        <FontRow label="14 - medium" className="fs-14 fw-medium" />
        <FontRow label="14 - bold" className="fs-14 fw-bold" />
        <FontRow label="14 - extrabold" className="fs-14 fw-extrabold" />

        <FontRow label="16 - semibold" className="fs-16 fw-semibold" />
        <FontRow label="16 - bold" className="fs-16 fw-bold" />
        <FontRow label="16 - BOLD UPPER" className="fs-16 fw-bold upper" />
        <FontRow label="16 - extrabold" className="fs-16 fw-extrabold" />
        <FontRow label="16 - black" className="fs-16 fw-black" />

        <FontRow label="18 - SEMIBOLD UPPER" className="fs-18 fw-semibold upper" />
        <FontRow label="18 - BLACK UPPER" className="fs-18 fw-black upper" />

        <FontRow label="20 - BOLD" className="fs-20 fw-bold" />
      </div>
    </section>
  );
}

function FontRow({ label, className }) {
  return (
    <div className="ui-font-row">
      <div className={`ui-font-sample ${className}`}>
        The quick brown fox jumps over the lazy dog
      </div>
      <div className="ui-font-label">{label}</div>
    </div>
  );
}
